module.exports = __webpack_public_path__ + "img/banner3.f78df4ba.jpg";